<template>
  <div class="save-pop-wrap"
       @scroll.stop
       @touchmove.prevent
       @click="hide">
    <div class="content">
      <img v-if="deviceType!=='weixin'"
           src="https://s.kcimg.cn/topic/images/futian-era/share_browser.png"
           alt="">
      <img v-if="deviceType==='weixin'"
           src="https://s.kcimg.cn/topic/images/futian-era/share_wx.png"
           alt="">
    </div>
  </div>
</template>
<script>
export default {
  props: {
  },
  data: () => ({
  }),
  methods: {
    hide () {
      this.$emit('shareHide', false)
    }
  }
}
</script>
<style lang="less" scoped>
.save-pop-wrap {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 100000000000000000000;
  .content {
    width: 100%;
    img {
      width: 100%;
    }
  }
}
</style>
